export function getCurrencySymbol(
  currencyCode: string,
  locale: string = "en-US",
): string {
  const formatter = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  });

  const formatted = formatter.format(1);
  return formatted.replace(/\d+\.?\d*/g, "").trim();
}

export const formatCash = (
  n: number | null | undefined,
  currencyCode: string | null = "usd",
) => {
  if (!currencyCode || n === undefined || n === null) {
    return "";
  }

  const ranges = [
    { divider: 1e9, suffix: "B" },
    { divider: 1e6, suffix: "M" },
    { divider: 1e3, suffix: "K" },
    { divider: 1, suffix: "" },
  ];

  let symbol = getCurrencySymbol(currencyCode);
  let amount = Math.abs(n);
  let sign = n < 0 ? "-" : "";

  if (n === 0) {
    return symbol + "0";
  }

  for (let i = 0; i < ranges.length; i++) {
    if (amount >= ranges[i].divider) {
      const value = amount / ranges[i].divider;
      const decimalPlaces = value % 1 === 0 ? 0 : 2;
      return sign + symbol + value.toFixed(decimalPlaces) + ranges[i].suffix;
    }
  }

  if (amount < 1) {
    return sign + symbol + amount.toFixed(2);
  }
};

export const formatCashFull = (
  n: number | null | undefined,
  currencyCode: string | null = "usd",
  alwaysDisplayCents: boolean = true,
  neverDisplayCents: boolean = false,
) => {
  if (!currencyCode || n === undefined || n === null) {
    return "";
  }

  const hasCents = n % 1 !== 0;

  const options: Intl.NumberFormatOptions = {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: neverDisplayCents
      ? 0
      : alwaysDisplayCents || hasCents
        ? 2
        : 0,
    maximumFractionDigits: neverDisplayCents
      ? 0
      : alwaysDisplayCents || hasCents
        ? 2
        : 0,
  };

  const formatter = new Intl.NumberFormat("en-US", options);

  return formatter.format(n);
};

export type Amount = {
  amount?: number | null;
  currencyCode?: string | null;
};

export const formatAmount = (value?: Amount | null): string => {
  if (value?.amount === undefined || value?.amount === null) return "";

  return formatCashFull(value.amount, value.currencyCode ?? "usd");
};
